import { ErrorMessages } from '../constants';
export default function responseHandler(status, response) {
  if (status >= 200 && status < 300) {
    return Promise.resolve({
      ok: true,
      status: status,
      response: response
    }); // Usually a 422 from Flow API with validation errors
  }

  if (response) {
    return Promise.resolve({
      ok: false,
      status: status,
      error: response
    }); // Handle case where response is an error and body is empty
  }

  return Promise.resolve({
    ok: false,
    status: status,
    error: {
      messages: [ErrorMessages.NETWORK_ERROR]
    }
  });
}
//# sourceMappingURL=responseHandler.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/web-sdk/dist/esm/net/responseHandler.js
// module id = 228
// module chunks = 0 1